import React, { Fragment, useEffect, useRef, useState } from "react";
import LeftBanner from "../../components/LeftColumnBanner";
import mobilePhone from "../../assets/images/phone.svg";
import infinity from "../../assets/images/unlimited-icon.svg";
import { makeStyles, Tooltip } from "@material-ui/core";
import PaymentPopUp from "../Payment/PaymentPopUp";
import moment from "moment";
import ErrorPopUp from "../../components/ErrorPopUp";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import queryString from "query-string";
import nonTouristBanner from "../../assets/images/hero-banner.png";
import touristBanner from "../../assets/images/Travelers-Sim_banner.png";

const useStyles = makeStyles((theme) => ({
	arrow: {
		"&:before": {
			border: "1px solid #3d5265",
		},
		color: "#fff",
	},
	tooltip: {
		backgroundColor: theme.palette.common.white,
		border: "1px solid #3d5265",
		color: "#3d5265",
		fontSize: "16px",
	},
}));

const Home = (props) => {
	const classes = useStyles();
	const {
		t,
		getBalanceUsage,
		balanceUsageData,
		paymentInitializer,
		paymentInitData,
		paymentSubmit,
		paymentURL,
		getPaymentData,
		paymentDataAfterPayment,
		paypalInitData,
		getPaypalInit,
		callLoginInit,
		paypalLoginInitData,
		paypalComplete,
		paypalSubmit,
		paypalSubmitData,
		getPaymentPaypalData,
		getDataPaymentPaypal,
		loading,
		amounts,
		getPDF,
		getAmounts,
		payloadAfterLogIn,
		pdf,
		getVoucherPayment,
		voucherMsg,
		receiveEmail,
		emailHasBeenSent,
		errorMessageHandler,
		errorMessageHandlerVoucher,
		errorMessageHandlerCardInit,
		errorMessageHandlerPaypalInit,
		errorMessageHandlerAmounts,
		errorSubmitPaypal,
		errorPaypalGetData,
		errorEmailSent,
		errorGetPaymentData,
	} = props;
	const [open, setOpen] = useState(false);
	const [paymentPopupConfig, setPaymentPopupConfig] = useState({
		initialStep: 0,
		initialAmount: 0,
	});
	const [usageData, setUsageData] = useState({});
	const [openErrorPopUp, setOpenErrorPopUp] = useState(false);
	const processedReturnMerchantRef = useRef(null);
	const [touristPaymentLookupFailed, setTouristPaymentLookupFailed] =
		useState(false);

	const { loading: balanceUsageLoading } = useSelector(
		(state) => state.BalanceReducer,
	);

	const prepaidMBLevel = [104857600, 524288000, 1572864000, 2621440000];

	useEffect(() => {
		if (
			Object.keys(balanceUsageData).length === 0 &&
			Object.keys(payloadAfterLogIn).length !== 0
		) {
			getBalanceUsage();
		} else if (errorMessageHandler) {
			setTouristPaymentLookupFailed(false);
			setOpenErrorPopUp(true);
		}
	}, [balanceUsageData, getBalanceUsage, payloadAfterLogIn]);

	useEffect(() => {
		if (!payloadAfterLogIn?.isTourist) return;
		const { merchantRef } = queryString.parse(window.location.search);
		if (!merchantRef) return;
		if (Object.keys(paymentDataAfterPayment).length === 0) return;
		if (paymentDataAfterPayment.success !== false) return;
		setTouristPaymentLookupFailed(true);
		setOpenErrorPopUp(true);
		setOpen(false);
		setPaymentPopupConfig({ initialStep: 0, initialAmount: 0 });
	}, [payloadAfterLogIn?.isTourist, paymentDataAfterPayment]);

	useEffect(() => {
		if (
			Object.keys(balanceUsageData).length !== 0 &&
			payloadAfterLogIn.token !== undefined &&
			Object.keys(payloadAfterLogIn.token).length !== 0
		) {
			const bundles =
				Array.isArray(balanceUsageData.bundles) &&
				balanceUsageData.bundles.length > 0
					? balanceUsageData.bundles
					: [{ remaining: 0, unlimited: false }];

			setUsageData({ ...balanceUsageData, bundles });
		}
	}, [balanceUsageData, payloadAfterLogIn]);

	const handleClose = () => {
		setOpen(false);
		setPaymentPopupConfig({ initialStep: 0, initialAmount: 0 });
	};

	const closeHomeErrorPopUp = () => {
		setOpenErrorPopUp(false);
		setTouristPaymentLookupFailed(false);
	};

	const handleOpen = (config = {}) => {
		setPaymentPopupConfig({
			initialStep:
				typeof config.initialStep === "number" ? config.initialStep : 0,
			initialAmount:
				typeof config.initialAmount === "number" ? config.initialAmount : 0,
		});
		setOpen(true);
	};

	useEffect(() => {
		if (!payloadAfterLogIn?.isTourist) return;
		const { merchantRef } = queryString.parse(window.location.search);
		if (!merchantRef) return;
		if (processedReturnMerchantRef.current === merchantRef) return;

		processedReturnMerchantRef.current = merchantRef;
		getPaymentData({ merchantRef });
		handleOpen({ initialStep: 1 });
	}, [payloadAfterLogIn, getPaymentData]);

	const handleNavigatePackages = () => {
		props.history.push("/packages");
	};

	const getWholeAndDecimal = (value) => {
		const [whole, decimal] = String(value).split(",");
		return [Number(whole), Number(decimal)];
	};

	const calculateRemainingData = (data) => {
		if (Object.keys(data).length !== 0) {
			let remainingFu = data.remaining;
			let divisor = 1048576;
			let output = Math.round(remainingFu / divisor);
			return output;
		} else {
			return 0;
		}
	};

	const calculateStrokeOffset = (data) => {
		if (Object.keys(data).length !== 0) {
			let grantFu = 0;
			if (data.remaining < prepaidMBLevel[0]) {
				grantFu = prepaidMBLevel[0];
			} else if (
				data.remaining > prepaidMBLevel[0] &&
				data.remaining < prepaidMBLevel[1]
			) {
				grantFu = prepaidMBLevel[1];
			} else if (
				data.remaining > prepaidMBLevel[1] &&
				data.remaining < prepaidMBLevel[2]
			) {
				grantFu = prepaidMBLevel[2];
			} else {
				grantFu = prepaidMBLevel[3];
			}

			let percentageBalance = (data.remaining * 100) / grantFu;

			let strokeDashoffset;
			if (percentageBalance < 100) {
				strokeDashoffset = 98 - percentageBalance * 0.8;
			} else {
				strokeDashoffset = 18.0;
			}

			return strokeDashoffset;
		} else {
			return 98;
		}
	};

	const getDisplayBundles = () => {
		if (!usageData || Object.keys(usageData).length === 0) {
			return [];
		}

		if (Array.isArray(usageData.bundles) && usageData.bundles.length > 0) {
			return usageData.bundles;
		}

		return [{ remaining: 0, unlimited: false }];
	};

	const displayBundles = getDisplayBundles();

	let temp;
	if (balanceUsageLoading) {
		temp = (
			<div className="detailsContentRight">
				<div className="dataRemaining ">
					<span
						className="loadingSpinner"
						style={{
							display: "block",
							position: "static",
							border: "4px solid #3d5265",
							borderRightColor: "transparent",
							margin: "0 auto",
						}}
					/>
				</div>
			</div>
		);
	} else if (displayBundles.length > 0) {
		temp = (
			<div>
				{displayBundles.map((d, index) => (
					<div
						key={index}
						className="detailsContentRight"
						style={{ minWidth: 96 }}
					>
						<div
							className="dataRemaining "
							style={{ minWidth: 96, width: 96, margin: "24px auto 10px" }}
						>
							{balanceUsageLoading ? (
								<span
									className="loadingSpinner"
									style={{
										display: "block",
										position: "static",
										border: "4px solid #3d5265",
										borderRightColor: "transparent",
										margin: "0 auto",
									}}
								/>
							) : (
								<svg
									className="donut"
									viewBox="0 0 35 35"
									width="96"
									height="96"
									xmlns="http://www.w3.org/2000/svg"
								>
									<linearGradient
										id="donutGradient6979461820undefined"
										x1="10%"
										y1="0%"
										x2="100%"
										y2="80%"
										gradientTransform="rotate(0)"
									>
										<stop
											offset="0%"
											stopColor={
												payloadAfterLogIn?.isTourist ? "#004b87" : "#00a0dc"
											}
										></stop>
										<stop
											offset="33%"
											stopColor={
												payloadAfterLogIn?.isTourist ? "#004b87" : "#3b61a6"
											}
										></stop>
										<stop
											offset="66%"
											stopColor={
												payloadAfterLogIn?.isTourist ? "#004b87" : "#509e2f"
											}
										></stop>
										<stop
											offset="100%"
											stopColor={
												payloadAfterLogIn?.isTourist ? "#004b87" : "#97d700"
											}
										></stop>
									</linearGradient>
									<circle
										className="donutBackground"
										stroke="#F7F7F7"
										strokeWidth="2"
										fill="none"
										strokeLinecap="round"
										strokeDasharray="98,100"
										cx="17.5"
										cy="17.5"
										r="15.91549431"
									></circle>
									<circle
										className="donutColor"
										stroke="black"
										strokeWidth="2"
										strokeDasharray="98,100"
										strokeDashoffset={calculateStrokeOffset(d)}
										strokeLinecap="round"
										fill="none"
										cx="17.5"
										cy="17.5"
										r="15.91549431"
									></circle>
								</svg>
							)}
							<span className="dataRemainingNumber">
								{!d.unlimited ? (
									calculateRemainingData(d)
								) : (
									<span className="dataRemainingNumber unlimmited">
										<img
											className="infinityImage"
											src={infinity}
											alt={t("infinity")}
										/>
										<div className="infinityDiv">{t("unlimitedData")}</div>
									</span>
								)}
							</span>
							<div className="dataSymbolContainer">
								<span className="dataSymbol">MB</span>
							</div>
						</div>
						{d.expiration ? (
							<div className=" paymentDeadline">
								<div className="textb">{t("expire")}</div>
								<div>{d.expiration}</div>
							</div>
						) : null}
					</div>
				))}
			</div>
		);
	} else {
		temp = null;
	}

	return (
		<Fragment>
			<div className="wrapper">
				<div className="banner-outer">
					<div className="banner-central-area-box">
						<img
							src={
								payloadAfterLogIn?.isTourist ? touristBanner : nonTouristBanner
							}
							alt={
								payloadAfterLogIn?.isTourist
									? "Travelers SIM"
									: "Prepaid Mobile Internet"
							}
						/>
					</div>
				</div>
				<div className="row">
					<LeftBanner />
					<div className="col-xs-6 active main-column-width">
						<div className="searchFilterContainer">
							<div className="box topBox mainContent withContent">
								<span className="sectionTitle">{t("oneLook")}</span>
							</div>
							{payloadAfterLogIn && !payloadAfterLogIn.isTourist ? (
								<div className="box withMargin detailsBox withOverflow">
									<div className="detailsIcon withoutIcon">
										<div>{t("balance")}</div>
									</div>
									<div className="detailsContent">
										<div className="detailsContentLeft">
											<div className="packageInfo">
												<div className="packageInfoTitle">
													{t("detailsContent")}: {payloadAfterLogIn.msisdn}
												</div>
												<div className="packageInfoContent">
													<div className="packageInfoBox large texti">
														{t("latestUpdate")}:{" "}
														{moment().format("DD/MM/YYYY HH:mm")}
													</div>
												</div>
												<div className="buttonOuter">
													<Link
														to="/packages"
														className="button primaryButton primaryButtonNormal"
													>
														{t("buyPackage")}
													</Link>
												</div>
											</div>
										</div>
										<div className="detailsContentRight">
											{Object.keys(usageData).length !== 0 ? (
												<Fragment>
													<div className="toPay">
														<div className="euros">
															<div className="bgIcon imgEuro">€</div>
															{getWholeAndDecimal(usageData.balance)[0]}
														</div>
														<div className="cents">
															.{getWholeAndDecimal(usageData.balance)[1]}{" "}
															<Tooltip
																title={t("tooltipContent")}
																arrow
																classes={{
																	arrow: classes.arrow,
																	tooltip: classes.tooltip,
																}}
															>
																<a className="bgIcon imgTooltip">i</a>
															</Tooltip>
														</div>
													</div>
													<div className=" paymentDeadline">{t("balance")}</div>
													<div className=" paymentDeadline">
														<div>
															<div className="textb">{t("expire")}</div>
															<div>{usageData.balanceExpiration}</div>
														</div>
													</div>
												</Fragment>
											) : null}
										</div>
									</div>
								</div>
							) : null}
						</div>
						<div>
							<div>
								<div className="withErrorState searchFilterBox">
									<div className="box withMargin detailsBox withOverflow">
										<div className="detailsIcon withoutIcon">
											<div>
												<img
													className="mobile-svg"
													src={mobilePhone}
													alt="mobile phone"
												/>
												{t("usageMB")}
											</div>
										</div>
										<div className="detailsContent">
											<div className="detailsContentLeft">
												<div className="packageInfo">
													<div className="packageInfoTitle">
														{t("detailsContent")}: {payloadAfterLogIn.msisdn}
													</div>
													<div className="packageInfoContent">
														{Object.keys(usageData).length !== 0 ? (
															<div className="packageInfoBox large">
																{t("refresh")}
															</div>
														) : (
															<div
																className="packageInfoBox large"
																style={{
																	fontWeight: "bold",
																	fontStyle: "italic",
																}}
															>
																{t("emptyUsageDataMessage")}
															</div>
														)}
														<div className="packageInfoBox large">
															<div className="packageInfoBoxText textb">
																{t("note")}:
															</div>
															{t("noteContent")}
														</div>
													</div>
													<div className="buttonOuter">
														<a
															className="button primaryButton primaryButtonNormal"
															onClick={
																payloadAfterLogIn?.isTourist
																	? handleNavigatePackages
																	: handleOpen
															}
														>
															{t(
																payloadAfterLogIn?.isTourist
																	? "buyPackage"
																	: "renewal",
															)}
														</a>
													</div>
												</div>
											</div>
											{temp}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-3 left-column-hide"></div>
				</div>
				{open ? (
					<PaymentPopUp
						paymentInitializer={paymentInitializer}
						paymentInitData={paymentInitData}
						t={t}
						getAmounts={getAmounts}
						amounts={amounts}
						setOpen={setOpen}
						open={open}
						handleClose={handleClose}
						paymentSubmit={paymentSubmit}
						paymentURL={paymentURL}
						getPaymentData={getPaymentData}
						paymentDataAfterPayment={paymentDataAfterPayment}
						paypalInitData={paypalInitData}
						getPaypalInit={getPaypalInit}
						callLoginInit={callLoginInit}
						paypalLoginInitData={paypalLoginInitData}
						paypalComplete={paypalComplete}
						paypalSubmit={paypalSubmit}
						paypalSubmitData={paypalSubmitData}
						getPaymentPaypalData={getPaymentPaypalData}
						getDataPaymentPaypal={getDataPaymentPaypal}
						loading={loading}
						getPDF={getPDF}
						pdf={pdf}
						getVoucherPayment={getVoucherPayment}
						voucherMsg={voucherMsg}
						receiveEmail={receiveEmail}
						emailHasBeenSent={emailHasBeenSent}
						errorMessageHandler={errorMessageHandler}
						errorMessageHandlerVoucher={errorMessageHandlerVoucher}
						errorMessageHandlerCardInit={errorMessageHandlerCardInit}
						errorMessageHandlerPaypalInit={errorMessageHandlerPaypalInit}
						errorMessageHandlerAmounts={errorMessageHandlerAmounts}
						errorSubmitPaypal={errorSubmitPaypal}
						errorPaypalGetData={errorPaypalGetData}
						errorEmailSent={errorEmailSent}
						initialStep={paymentPopupConfig.initialStep}
						initialAmount={paymentPopupConfig.initialAmount}
					/>
				) : null}
				{openErrorPopUp ? (
					<ErrorPopUp
						setOpenErrorPopUp={closeHomeErrorPopUp}
						openErrorPopUp={openErrorPopUp}
						t={t}
						text={
							touristPaymentLookupFailed ? t("paymentError") : t("errorGeneral")
						}
						errorGetPaymentData={errorGetPaymentData}
						paymentDataAfterPayment={paymentDataAfterPayment}
					/>
				) : null}
			</div>
		</Fragment>
	);
};

export default Home;
